import {useState} from 'react'
import {platformNames,softwareApi} from '../Software'
export default function CatalogClassification({service,onChanged}){
  const [platform,setPlatform]=useState('android'),[busy,setBusy]=useState(false),[error,setError]=useState('')
  if(!service)return null
  const connected=service.dev_target!=='unconfigured:development'||service.prod_target!=='unconfigured:production'
  async function move(){setBusy(true);setError('');try{
    await softwareApi(`/services/${service.service_id}/classification`,{method:'PUT',body:JSON.stringify({kind:'software',expectedKind:'server',platforms:[platform]})})
    await onChanged()
  }catch(e){setError(e.message)}finally{setBusy(false)}}
  return <details className="deploy-disclosure"><summary>서버·소프트웨어 분류</summary><section className="deploy-panel">
    <h2>설치형 소프트웨어로 분류</h2><p>Android 앱·Windows 설치 프로그램처럼 파일이나 스토어로 배포하는 제품은 소프트웨어 출시에서 관리합니다.</p>
    {connected?<p>이 항목에는 서버 실행 대상이 연결되어 있습니다. 서버와 앱이 함께 있는 저장소라면 <a href="/software">소프트웨어 항목을 별도로 등록</a>해 주세요.</p>
    :<div className="deploy-form"><label>플랫폼<select value={platform} onChange={e=>setPlatform(e.target.value)}>{Object.entries(platformNames).map(([key,label])=><option value={key} key={key}>{label}</option>)}</select></label>
      <button disabled={busy} onClick={move}>{busy?'분류 변경 중':'소프트웨어 출시로 이동'}</button></div>}
    {error&&<p className="deploy-error" role="alert">{error}</p>}
  </section></details>
}
